module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/pistoia.0dbc120a42305a539f349b813ed7c315.jpg";